/**
 * @generated SignedSource<<bea1cf48d37ee1b33892cabe98721384>>
 * @relayHash e0d0ca312e455dd89cba54cfb1984fbb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e

import type { ConcreteRequest } from 'relay-runtime';
export type useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery$variables = {
  selectedSpaceKey?: string | null | undefined;
};
export type useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery$data = {
  readonly myVisitedSpaces: {
    readonly nodes: {
      readonly spaces: ReadonlyArray<{
        readonly alias: string | null | undefined;
        readonly icon: {
          readonly path: string;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly name: string | null | undefined;
        readonly status: string | null | undefined;
      } | null | undefined> | null | undefined;
    };
  } | null | undefined;
  readonly space: {
    readonly alias: string | null | undefined;
    readonly currentUser: {
      readonly isFavourited: boolean;
    };
    readonly icon: {
      readonly path: string;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
    readonly name: string | null | undefined;
    readonly status: string | null | undefined;
  } | null | undefined;
};
export type useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery = {
  response: useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery$data;
  variables: useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedSpaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "alias"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = {
  "kind": "ScalarField",
  "name": "status"
},
v6 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v7 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "selectedSpaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isFavourited"
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Literal",
        "name": "limit",
        "value": 26
      }
    ],
    "concreteType": "MyVisitedSpaces",
    "kind": "LinkedField",
    "name": "myVisitedSpaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "MyVisitedSpacesItems",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": false,
        "selections": [
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "storageKey": "myVisitedSpaces(limit:26)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
    "selections": (v7/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "e0d0ca312e455dd89cba54cfb1984fbb",
    "id": "526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e",
    "metadata": {},
    "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
    "operationKind": "query",
    "text": "query useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias,id,name,key,status,icon{path},currentUser{isFavourited}},myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
  }
};
})();

(node as any).hash = "24da03b127211694c7ed862f0d6a1ac9";

export default node;
